/* eslint-disable object-shorthand */
/* eslint-disable no-param-reassign */
import { call, put, select } from 'redux-saga/effects';
import {
  actions as mainActions,
  SONDA_KIND,
} from '@gcloud-npm/next12.app-controller.reducers-sagas.main-reducer-n';
import { getStaticContent } from '@gcloud-npm/next12.adabyron.misc.get-static-content';
import { actions as constantsActions } from '@/reducers/constants';
import { normalizeBusinessProps } from './normalizers/constants';

const filePath = 'sagas/common.js';

const fakeConstants = {
  interesLabel: 'Me interesa',
  c2cLabel: 'Hablar con experto',
  visitaLabel: 'Solicitar visita',
  contratarAsistidoLabel: 'Contratar con experto',
  contratarOnlineLabel: 'Contratar online',
  infoLabel: 'Más información',
  horarioLabel: 'Horario de atención: L-V de 9 a 19 h',
  modalAtencionConfig: {
    default: {
      tabOptionPreChecked: 'te-llamamos',
      tabsAvaliable: {
        'te-llamamos': {
          print900: false,
          empleados: true,
          empleadosOptions: [
            { value: 'Menos de 10 empleados', label: 'Menos de 10 empleados' },
            { value: 'De 10 a 249 empleados', label: 'De 10 a 249 empleados' },
            { value: 'Más de 249 empleados', label: 'Más de 249 empleados' },
          ],
          allowNIF: false,
          email: false,
          title:
            'Déjanos tus datos y un experto contactará contigo para resolver dudas sobre el máster gratuito para directivos. Si ya eres cliente, te llamará tu comercial.',
          text: 'Por teléfono',
          icon: 'Fijo',
          encaminamiento: [
            {
              porcentaje: 0,
              destino: 'Gevico',
              tes: 'SI',
              tipoTes: 'SVC_C',
            },
            {
              porcentaje: 100,
              destino: 'InsideSales',
              tes: 'SI',
              tipoTes: 'ME_C',
            },
          ],
        },
      },
    },
  },
};

const contextStore = (state) => state.main.context;

function* setFailureBusinessProps() {
  yield put(constantsActions.setBusinessConstants(null));
}

/**
 * Obtiene todos la info de las paginas en abierto (Orion)
 * @returns {undefined}
 */
export function* getBusinessProps({ path, build }) {
  const context = yield select(contextStore);

  const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
  try {
    let response = '';
    response = yield call(getStaticContent, {
      preRenderEnv: build && currentEnv === 'dev' ? 'prod' : null,
      context,
      resourcePath: `/static/json/constants/constantsEmp.json`,
    });

    const normalizedResponse = normalizeBusinessProps(response, path);

    if (normalizedResponse) {
      yield put(constantsActions.setBusinessConstants(normalizedResponse));
    }
  } catch (error) {
    yield put(
      mainActions.throwSonda({
        error,
        filePath,
        kind: SONDA_KIND.SEVERAL,
        processName: 'getBusinessProps',
      })
    );
    yield call(setFailureBusinessProps);
  }
}
